import { AccessTypes, siteScreenNavigation } from "./constants";
import roles from "./roles";
import i18n from "i18n";

/**
 * Centralized site navigation builder
 * This eliminates the need for every component to manually build navigation arrays
 */
export const buildSiteNavigation = (userRole, isSiteUser, customCaptions, position) => {
	// Localised tab names: the site's custom caption when present, otherwise the
	// translated default entity term (never a hardcoded English fallback).
	const detailsItem = {
		name: i18n.t("title.details"),
		url: siteScreenNavigation[0].url,
	};
	const assetsItem = {
		name: customCaptions?.assetPlural || i18n.t("entity.asset", { count: 2 }),
		url: siteScreenNavigation[1].url,
	};
	const departmentsItem = {
		name:
			customCaptions?.departmentPlural ||
			i18n.t("entity.department", { count: 2 }),
		url: siteScreenNavigation[2].url,
	};

	// Super admin: no assets tab.
	if (userRole === roles.superAdmin) {
		return [detailsItem, departmentsItem];
	}

	// Site user: the assets tab only when they have asset access.
	if (userRole === roles.siteUser || isSiteUser) {
		const hasAssetAccess = position?.assetAccess !== AccessTypes.None;
		return hasAssetAccess
			? [detailsItem, assetsItem, departmentsItem]
			: [detailsItem, departmentsItem];
	}

	// Client admin and other roles: the full localised navigation.
	return [detailsItem, assetsItem, departmentsItem];
};

/**
 * Hook to get site navigation for current user
 */
export const useSiteNavigation = (userInfo) => {
	const { role, isSiteUser, customCaptions, position } = userInfo;
	return buildSiteNavigation(role, isSiteUser, customCaptions, position);
};

/**
 * Get site navigation with user data from localStorage
 */
export const getSiteNavigationFromStorage = (getLocalStorageData) => {
	const userInfo = getLocalStorageData("me");
	return buildSiteNavigation(
		userInfo.role,
		userInfo.isSiteUser,
		userInfo.customCaptions,
		userInfo.position
	);
};